<template>
  <components
    ref="form"
    :forms="forms"
    :is="config.name"
    :mode="mode"
    v-model="_value"
    v-bind="config.props"
    :labelName="labelName"
    :config1="config"
    @input="input"
  />
</template>
<script>
import components from '@/views/common/form/ComponentExport'

export default {
  name: 'FormRender1',
  components: components,
  props: {
    forms: {
      type: Array,
      default: () => {
        return []
      },
    },
    labelName:'',
    mode: {
      type: String,
      default: 'DESIGN',
    },
    value: {
      default: undefined,
    },
    config: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  created() {
    console.log(123456789)
    console.log(this.labelName, 'name')

    // const Copy = Object.assign({}, this.config);
    // const Copy = JSON.parse(JSON.stringify(this.config));
    // this.config1 = Copy;
    // console.log(this.config1, "config1");
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },

  methods: {
    validate(call) {
      this.$refs.form.validate(call)
    },
    input(val) {
      setTimeout(() => {
        this.$store.commit('updateFormItemValue', { id: this.config.id, value: val })
        this._value = val
        console.log(this._value, 'Pval')
      }, 10)
    },
  },
}
</script>

<style lang="less" scoped></style>
